module.exports = __webpack_public_path__ + "img/Weapon_07.043cef12.png";